<template>
  <span v-if="address">{{ address }}</span>
</template>

<script>
export default {
  name: 'AddressLine',

  props: {
    street: {
      type: String,
      default: ''
    },
    city: {
      type: String,
      default: ''
    },
    zip: {
      type: [String, Number],
      default: ''
    }
  },

  computed: {
    address() {
      return `${this.street ? this.street + ',' : ''} ${this.zip || ''} ${this
        .city || ''}`.replace(/^[\s,]+|[\s,]+$/g, '');
    }
  }
};
</script>
